const isLockedPresale = (tt) =>
  Boolean(tt.presale) && tt.visibility !== 'Visible' && !tt.sold_out && !tt.sales_ended && !tt.scheduled && !tt.sales_paused;

export default isLockedPresale;
